import { defineComponent, watch } from 'vue';
import { CapacitorGoogleLoginFunction } from 'src/plugins/google/CapacitorGoogleLogin';
export default defineComponent({
    name: 'capacitorGoogleLogin',
    props: {
        label: String,
        disable: Boolean,
        scope: {
            type: Array,
            default: () => {
                return ['email', 'profile'];
            }
        }
    },
    setup(props, context) {
        const { capacitorGoogleLogin, CapacitorGoogleLoggedIn } = CapacitorGoogleLoginFunction(props.scope, false);
        watch(CapacitorGoogleLoggedIn, (newValue) => {
            context.emit('logged-in', newValue);
        });
        return { capacitorGoogleLogin };
    },
    emits: ['logged-in']
});
